module.exports = __webpack_public_path__ + "img/SSWS_MODERN_sword.4f2aa0ee.png";